import React, { Component } from "react";
import "./home.css";
import Welcome from "./home-welcome";
import CarouselConecta from "./carousel-conecta";
import CarouselEssilor from "./carousel-essilor";
import AppContext from "../appContext";
import Swal from "sweetalert2";
import { Redirect } from "react-router-dom";
import { redirectPage } from "../components/utils/redirectpage";
import MESSAGES from "../shared/constants/messages";

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      categorias: [],
      especialistaPremiere: "",
      companyName: "",
    };

    Home.contextType = AppContext;
  }

  componentDidMount() {
    redirectPage(this.context.userSession, "/home");
    this.context.showLoading("Carregando módulos...");

    this.getModulesCategorias();
    window.localStorage.removeItem("@labatacado_hasLaboratorio");
    window.localStorage.removeItem("@labatacado_lab");
    window.localStorage.removeItem("@labatacado_otica");
    window.localStorage.removeItem("@labatacado_emp");
    window.localStorage.removeItem("@labatacado_emp_cnpj");
    window.localStorage.removeItem("emailLogin");
  }

  async fetchCompanyName(cnpj) {
    try {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ cnpj }),
      };

      const response = await fetch(process.env.REACT_APP_LABS_API + "get_account_data.php", requestOptions);
      const data = await response.json();

      if (data) {
				this.setState({ companyName: data.fantasia })
      }
    } catch (error) {
      console.error("Erro ao obter nome da empresa:", error);
    }
  }

  getModulesCategorias() {
    const cat = [];
    let modulos;

    modulos = this.isEspecialistaPremiere(this.context.userSession.modulos);
    const especialista = !!(this.context.especialistaPremiere && this.context.especialistaPremiere.includes("VARILUX"));

    const requestOptions1 = {
      method: "POST",
      body: JSON.stringify({
        modulos: modulos,
        especialista: especialista,
      }),
    };

    fetch(process.env.REACT_APP_LABS_API + "get_modules_categories.php", requestOptions1)
      .then(response => {
        return response.json();
      })
      .then(json => {
				console.log('Módulos recebidos:', json);
        if (json.status === 200 && json.items) {
          json.items.map((item, index) => {
            var mods = [];
            var catAux = {
              nome: item.RecordName,
              id: item.Id,
              ordem: item.Posicao_c,
            };

            item.modulos.map((items, index) => {
              let mensagemNovidade = null;
              let dataLimiteNovidade = null;
              if (items.MensagemNovidade_c) {
                mensagemNovidade = items.MensagemNovidade_c;
              } else if (items.MensagemDeNovidade_c) {
                mensagemNovidade = items.MensagemDeNovidade_c;
              }
              if (items.DataLimiteNovidade_c) {
                dataLimiteNovidade = items.DataLimiteNovidade_c;
              } else if (items.DataLimiteDaNovidade_c) {
                dataLimiteNovidade = items.DataLimiteDaNovidade_c;
              }

              var modAux = {
                nome: items.RecordName,
                pos: items.Posicao_c,
                url: items.URL_c,
                tab: items.NovaAba_c,
                logo: items.URL_Logo_c,
                message: items.Imagem_c,
                categoria: items.Categoria_mod_c,
                sso: items.SSO_c,
                piloto: items.OticasPilotos_c,
                mensagemNovidade: mensagemNovidade,
                dataLimiteNovidade: dataLimiteNovidade,
              };

              if (!items.OticasPilotos_c) {
                mods.push(modAux);
              } else {
                const contas = items.OticasPilotos_c.split(";");
                if (contas.some(elem => elem.includes(this.context.userSession.conta))) {
                  mods.push(modAux);
                }
              }
            });

            mods.sort(this.compare);
            catAux.modulos = mods;

            cat.push(catAux);
          });

          this.setState({ categorias: cat }, () => {
            this.state.categorias.sort(function (a, b) {
              return a.ordem - b.ordem;
            });
            this.setState({ isReady: true }, () => {
              this.context.hideLoading();
              this.isUsuarioSemCnpj();
              this.isNovoUsuarioOptica();
            });
          });
        } else {
          this.setState({ isReady: true }, () => {
            this.context.hideLoading();
            this.isUsuarioSemCnpj();
            this.isNovoUsuarioOptica();
          });
        }
      });
  }

  async isNovoUsuarioOptica() {
    const { papel, conta, laboratorios } = this.context.userSession;

		const mensagens = {
			optica: MESSAGES.NEW_OPTICAL_USER,
			lab: "Solicite a alteração do seu perfil de acesso entrando em contato com o suporte através da ferramenta <strong><a href='https://essilorluxottica.requestia.com/' target='_blank'>Requestia (https://essilorluxottica.requestia.com/)</a></strong> e informando seu <b>CNPJ</b> e <b>e-mail de cadastro</b> no Essilor Conecta",
			labIndependente: "Solicite a alteração do seu perfil de acesso entrando em contato com seu Consultor Essilor, informando seu <b>CNPJ</b> e <b>e-mail de cadastro</b> no Essilor Conecta",
      essilor: "Solicite a alteração do seu perfil de acesso entrando em contato com o suporte através da ferramenta <strong><a href='https://essilorluxottica.requestia.com/' target='_blank'>Requestia (https://essilorluxottica.requestia.com/)</a></strong> e informando seu <b>CNPJ</b> e <b>e-mail de cadastro</b> no Essilor Conecta",
			fallback: "<br>Solicite a alteração do seu perfil de acesso entrando em contato com o Atendimento. Basta enviar um e-mail para <b>duvidas@essilorpromo.com.br</b> informando seu <b>CNPJ</b> e <b>e-mail de cadastro</b> no Essilor Conecta."
		};

    const isNovoUsuario =
      papel === "Novo Usuário Óptica" ||
      papel === "Novo Usuário Laboratório" ||
      papel === "Novo Usuário Lab Independente" ||
      papel === "Novo Usuário Essilor";

    if (!isNovoUsuario) return;

    this.context.showLoading("Carregando módulos...");

    await this.fetchCompanyName(conta);

    const response = await fetch(process.env.REACT_APP_LABS_API + "get_users.php", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("session_token"),
      },
      body: JSON.stringify({ cnpj: conta }),
    }).then(res => res.json());

    const users = response?.items?.filter((item, index, self) =>
      self.findIndex(i => i.email === item.email) === index
    );

    const usuariosComPapel = users.filter(
      el =>
        (el.papel?.includes("Gerente") || el.papel?.includes("Proprietário")) &&
        el.inativo === false
    );

    const gerarMensagemUsuarios = (usuarios) => {
      if (!usuarios.length) return null;
      return (
        "<br/>Solicite ao(s) seguinte(s) usuário(s) para alterar seu perfil de acesso:<br/><br/>" +
        usuarios
          .map(u => `<strong>${u.nome} - ${u.email}</strong><br/>`)
          .join("")
      );
    };

    let mensagemFinal = "";
    if (papel === "Novo Usuário Óptica") {
      mensagemFinal = gerarMensagemUsuarios(usuariosComPapel) || `<br/>${mensagens.optica}.<br/>`;
    }else if (papel === "Novo Usuário Lab Independente") {
      const gerentesAtivos = users?.filter(u => u.papel?.includes("Gerente") && u.inativo === false);
      mensagemFinal = gerarMensagemUsuarios(gerentesAtivos) || `<br/>${mensagens.labIndependente}.<br/>`;
    } else if (papel === "Novo Usuário Laboratório") {
      const gerentesAtivos = users?.filter(u => u.papel?.includes("Gerente") && u.inativo === false);
      mensagemFinal = gerarMensagemUsuarios(gerentesAtivos) || `<br/>${mensagens.lab}.<br/>`;
    } else if (papel === "Novo Usuário Essilor") {
      mensagemFinal = `<br/>${mensagens.essilor}.<br/>`;
    }

    const hasGerenteOuProprietario = users?.some(
      el => (el.papel?.includes("Gerente") || el.papel?.includes("Proprietário"))
    );

    if (!hasGerenteOuProprietario && laboratorios.length === 0) {
      mensagemFinal = mensagens.fallback;
    }

    this.setState({ novoUsuarioMensagem: mensagemFinal });

    this.context.hideLoading();
    Swal.fire({
      title: "Atenção",
      html: `Bem vindo ao <b>Essilor Conecta, ${this.context.userSession.email}</b>!<br><br>Você é um novo usuário na empresa <strong>${this.state.companyName}</strong> e, por isso, seu acesso aos módulos é restrito.<br/>${mensagemFinal}`,
      icon: "warning",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "OK",
      scrollbarPadding: false,
    });
  }

  isEspecialistaPremiere(modulos) {
    if (this.context.especialistaPremiere === "VARILUX ESPECIALISTA PREMIER" || this.context.especialistaPremiere === "VARILUX ESPECIALISTA PLATINE") {
      return modulos;
    } else if (this.context.userSession.conta === "30260871000105" && this.context.userSession.papel === "Dev") {
      return modulos;
    } else {
			return modulos.filter((item) => {
        return item !== "Relacionamento Digital";
      });
    }
  }

  isUsuarioSemCnpj() {
    if (
      localStorage.getItem("isUsuarioSemCnpj") === "true" &&
      this.state.isReady &&
      !this.context.userSession.conta &&
      (this.context.userSession.papel.includes("Usuário não associado a"))
    ) {
      localStorage.setItem("isUsuarioSemCnpj", false);
      Swal.fire({
        title: "Atenção",
        text: "Você não está associado a nenhuma empresa no momento. Gostaria de atualizar esta informação?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then(result => {
        if (result.value) {
          this.setState({ redirectProfile: true });
        }
      });
    }
  }

  compare = (a, b) => {
    if (a.pos < b.pos) {
      return -1;
    }
    if (a.pos > b.pos) {
      return 1;
    }
    return 0;
  };

  render() {
    if (this.state.isReady) {
      if (this.state.redirectProfile) {
        return <Redirect to="/profile" />;
      }

      return (
        <div className="x-body" id="main-body">
          <main className="x-main homelog">
            <div className="x-main__first-container">
              <Welcome></Welcome>
              {this.state.categorias.map((item, index) => {
                return item.modulos && item.modulos.length > 0 && <CarouselEssilor key={index} categoria={item.nome} id={item.id} modulos={item.modulos} />;
              })}
            </div>
            <div className="x-main__second-container">
              <CarouselConecta></CarouselConecta>
            </div>
          </main>
        </div>
      );
    } else {
      return <></>;
    }
  }
}

export default Home;
